import { render, staticRenderFns } from "./EditRoleTag.vue?vue&type=template&id=48ddec00&scoped=true"
import script from "./EditRoleTag.vue?vue&type=script&lang=js"
export * from "./EditRoleTag.vue?vue&type=script&lang=js"
import style0 from "./EditRoleTag.vue?vue&type=style&index=0&id=48ddec00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ddec00",
  null
  
)

export default component.exports